<template>
    <div class="level-container">
        <div class="line"></div>
        <div class="top">
            <div class="desc">成长权益等级</div>
            <div class="desc-level">V1</div>
            <div class="desc-level2">V2</div>
            <div class="desc-level3">V3</div>
        </div>
        <div class="line"></div>
        <div class="bottom">
            <div class="desc">每年限领张数</div>
            <div class="desc-level">{{ list[0].count }}张</div>
            <div class="desc-level1">{{ list[1].count }}张</div>
            <div class="desc-level3">{{ list[2].count }}张</div>
            <div></div>
        </div>
        <div class="line"></div>
    </div>
</template>
<script>
export default {
    name: 'level',
    props: {
        list: {
            type: Array,
            default: []
        }
    },
    data() {
        return {};
    },
    created() {},
    methods: {}
};
</script>
<style lang="less" scoped>
@import '~@common/style/common.less';
.level-container {
    margin-top: 20.5px;

    height: 100%;
    overflow: hidden;
    width: 339px;
    margin-left: 18px;
    margin-right: 18px;
    .line {
        width: 339px;
        height: 1px;
        background-color: #e3ba8a;
    }
    .top {
        display: flex;
        background-color: #f5f6f8;
        height: 38px;
        align-items: center;
        align-content: center;
        .desc {
            color: #cf8f44;
            .f-12-bold();

            color: rgba(207, 143, 68, 1);
            line-height: 14px;
            margin-left: 12px;
        }
        .desc-level {
            margin-left: 47px;
            .f-12-bold();
            color: rgba(41, 39, 56, 1);
            line-height: 14px;
        }
        .desc-level2 {
            margin-left: 51px;
            .f-12-bold();
            color: rgba(41, 39, 56, 1);
            line-height: 14px;
        }
        .desc-level3 {
            margin-left: 51px;
            .f-12-bold();
            color: rgba(41, 39, 56, 1);
            line-height: 14px;
        }
    }
    .bottom {
        display: flex;
        height: 39px;
        align-items: center;
        align-content: center;
        .desc {
            color: #cf8f44;
            .f-12-bold();
            color: rgba(207, 143, 68, 1);
            line-height: 14px;
            margin-left: 12px;
        }
        .desc-level {
            margin-left: 46px;
            .f-12-bold();
            color: rgba(41, 39, 56, 1);
            line-height: 14px;
        }
        .desc-level1 {
            margin-left: 50px;
            .f-12-bold();
            color: rgba(41, 39, 56, 1);
            line-height: 14px;
        }
        .desc-level3 {
            margin-left: 48px;
            .f-12-bold();
            color: rgba(41, 39, 56, 1);
            line-height: 14px;
        }
    }
}
</style>
